import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  text?: string;
}
export function CTAButton({
  className = '',
  text = 'Try ReLive HexaCore Risk-Free for 30 Days',
  ...props
}: CTAButtonProps) {
  const handleClick = () => {
    window.open('https://relievelive.com/products/1-2-4pairs-latex-sport-insoles-soft-high-elasticity-shoe-pads-orthotic-breathable-shock-absorption-cushion-arch-support-insole', '_blank');
  };
  return <button className={`w-full bg-[#4a7c59] hover:bg-[#3d6649] text-white font-semibold py-4 px-8 rounded-md transition-colors duration-200 flex items-center justify-center gap-2 text-lg shadow-sm ${className}`} onClick={handleClick} {...props} data-id="element-1">
      {text}
      <ArrowRight className="w-5 h-5" data-id="element-2" />
    </button>;
}